<template>
    <div class="syccxhz" v-loading="loading">
        <div class="syccxhzHeader">
            <!--          <div></div>-->
            <div class="sycBottom">
                <p>{{date[0]}}年{{date[1]}}月份新能源汽车产销情况表</p>
            </div>
            <div class="sycDan">
                <p>单位：辆，%</p>
            </div>
        </div>
        <div>
            <table border="1" style="width: 100%;padding: 5px" class="hisTable" id="tal">
                <thead>
                    <tr class="headerClass">
                        <td colspan="2" rowspan="2">车型</td>
                        <td colspan="6">生产量</td>
                        <td colspan="6">销售量</td>
                        <td rowspan="2">本月产销率</td>
                        <td rowspan="2">本期产销率</td>
                    </tr>
                    <tr class="headerClass">
                        <td>本月完成</td>
                        <td>本月止累计</td>
                        <td>同期止累计</td>
                        <td>比上月增长</td>
                        <td>比同期增长</td>
                        <td>比同期累计增长</td>
                        <td>本月完成</td>
                        <td>本期止累计</td>
                        <td>同期止累计</td>
                        <td>比上月增长</td>
                        <td>比同期增长</td>
                        <td>比同期累计增长</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableData" :key="index">
                        <td v-if="item.zhibiao1dis != 'none' && item.zhibiao1 !='*'" :rowspan="item.zhibiao1span">{{item.zhibiao1}}</td>
                        <td v-if="item.zhibiao2dis != 'none' && item.zhibiao2 != '新能源汽车总计'" :rowspan="item.zhibiao2span">{{item.zhibiao2}}</td>
                        <td v-else colspan="2">{{item.zhibiao2}}</td>

                        <td>{{item.scBywc}}</td>
                        <td>{{item.scBqzlj}}</td>
                        <td>{{item.scTqzlj}}</td>
                        <td>{{item.scBsyzz}}</td>
                        <td>{{item.scBtqzz}}</td>
                        <td>{{item.scBtqljzz}}</td>

                        <td>{{item.xsBywc}}</td>
                        <td>{{item.xsBqzlj}}</td>
                        <td>{{item.xsTqzlj}}</td>
                        <td>{{item.xsBsyzz}}</td>
                        <td>{{item.xsBtqzz}}</td>
                        <td>{{item.xsBtqljzz}}</td>

                         <td>{{item.bycxl}}</td>
                        <td>{{item.bqcxl}}</td>
                    </tr>
                </tbody>

            </table>

            <h3>注：表中数据包括插电式混合动力汽车、纯电动汽车、燃料电池汽车。</h3>
        </div>
    </div>
</template>
<script>
import { getXnyQccxqkb } from "@/api/data";
import { combineCell } from "@/utils/tableData.js";
export default {
    data() {
        return {
            tableData: [],
            date: null,
            loading:true
        };
    },
    created() {
        let date = this.$route.params.date;
        this.date = date.split("-");
        this.getXnyQccxqkb(date.split("-").join(""));
    },
    methods: {
        getXnyQccxqkb(date) {
            getXnyQccxqkb({ dataDate: date }).then((res) => {
                if (res.code == 200) {
                    this.tableData = combineCell(res.data);
                }
                this.loading = false
            });
        },
    },
};
</script>
<style scoped lang="css">
.hisTable {
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
}
.headerClass {
    font-size: 16px;
    color: white;
    background-color: #0d57bc;
}
.trOne {
    font-weight: bold;
}
.syccxhzHeader {
    width: 100%;
    height: 90px;

    font-size: 22px;
    text-align: center;
}
.sycBottom {
    width: 100%;
    height: 70px;
    line-height: 70px;

    float: right;
    font-weight: bold;
}
.sycDan {
    width: 10%;
    height: 20px;

    float: right;
    font-size: 13px;
}
</style>